import { GetPortraitResponse } from "tng-address-collection-shared/types/portraitsApiTypes.ts";
import { isUnderWay } from "./usePortrait";

export type Stage = "card" | "photo" | "christmasImage";

/** The finished card comes first; without one, the next step towards it */
export const arrivalStage = ({
  cutout,
  christmasImage,
  choice,
}: GetPortraitResponse): Stage => {
  if (!cutout?.imageUrl || isUnderWay(cutout)) {
    return "photo";
  }
  if (isUnderWay(christmasImage) || !choice) {
    return "christmasImage";
  }
  return "card";
};

export const lacksChristmasImage = ({ christmasImage }: GetPortraitResponse) =>
  !christmasImage?.imageUrl && !isUnderWay(christmasImage);
